module.exports = __webpack_public_path__ + "static/media/cloud_icon.64d79488.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud_icon.svg
// module id = 1226
// module chunks = 0